//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.18.2.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class AuthorizedApiBase {
    private readonly config: IConfig;

    protected constructor(config: IConfig) {
        this.config = config;
    }

    protected transformOptions = (options: RequestInit): Promise<RequestInit> => {
        //options.headers = {
        //    ...options.headers,
        //    Authorization: this.config.getAuthorization(),
        //};
        return Promise.resolve(options);
    };
}

export class AccountClient extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    create(model: CreateAccountModel): Promise<void> {
        let url_ = this.baseUrl + "/api/Account/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 302) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    login(model: LoginModel): Promise<void> {
        let url_ = this.baseUrl + "/api/Account/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLogin(_response);
        });
    }

    protected processLogin(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    loginAs(model: LoginAsModel): Promise<void> {
        let url_ = this.baseUrl + "/api/Account/loginas";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLoginAs(_response);
        });
    }

    protected processLoginAs(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    forgotPassword(model: ForgotPasswordModel): Promise<void> {
        let url_ = this.baseUrl + "/api/Account/forgotpassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processForgotPassword(_response);
        });
    }

    protected processForgotPassword(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    resetPassword(model: ResetPasswordModel): Promise<void> {
        let url_ = this.baseUrl + "/api/Account/resetpassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processResetPassword(_response);
        });
    }

    protected processResetPassword(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    logout(): Promise<void> {
        let url_ = this.baseUrl + "/api/Account/logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLogout(_response);
        });
    }

    protected processLogout(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class AppConfigClient extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(): Promise<ConfigurationDto> {
        let url_ = this.baseUrl + "/api/AppConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<ConfigurationDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConfigurationDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConfigurationDto>(null as any);
    }
}

export class BlogClient extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(limit: number | undefined): Promise<PostDto[]> {
        let url_ = this.baseUrl + "/api/Blog?";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<PostDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PostDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PostDto[]>(null as any);
    }
}

export class FagClient extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(): Promise<FagDto[]> {
        let url_ = this.baseUrl + "/api/Fag";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<FagDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FagDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FagDto[]>(null as any);
    }
}

export class FileClient extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getUploadUrl(fileName: string | null | undefined, fileSize: number | undefined): Promise<FileUploadResponseDto> {
        let url_ = this.baseUrl + "/api/File/GetUploadUrl?";
        if (fileName !== undefined && fileName !== null)
            url_ += "FileName=" + encodeURIComponent("" + fileName) + "&";
        if (fileSize === null)
            throw new Error("The parameter 'fileSize' cannot be null.");
        else if (fileSize !== undefined)
            url_ += "FileSize=" + encodeURIComponent("" + fileSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUploadUrl(_response);
        });
    }

    protected processGetUploadUrl(response: Response): Promise<FileUploadResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileUploadResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileUploadResponseDto>(null as any);
    }

    getValidFiletypes(): Promise<ValidFiletypesDto> {
        let url_ = this.baseUrl + "/api/File/GetValidFiletypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetValidFiletypes(_response);
        });
    }

    protected processGetValidFiletypes(response: Response): Promise<ValidFiletypesDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValidFiletypesDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidFiletypesDto>(null as any);
    }

    getFile(blobproviderMetadataGuid: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/File/GetFile?";
        if (blobproviderMetadataGuid === null)
            throw new Error("The parameter 'blobproviderMetadataGuid' cannot be null.");
        else if (blobproviderMetadataGuid !== undefined)
            url_ += "blobproviderMetadataGuid=" + encodeURIComponent("" + blobproviderMetadataGuid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFile(_response);
        });
    }

    protected processGetFile(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    afslutUpload(model: AfslutFileUploadModel): Promise<AfslutUploadResponseDto> {
        let url_ = this.baseUrl + "/api/File/AfslutUpload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAfslutUpload(_response);
        });
    }

    protected processAfslutUpload(response: Response): Promise<AfslutUploadResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AfslutUploadResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AfslutUploadResponseDto>(null as any);
    }
}

export class ForloebClient extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    create(model: ForloebModel): Promise<ForloebModel> {
        let url_ = this.baseUrl + "/api/Forloeb/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<ForloebModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ForloebModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ForloebModel>(null as any);
    }

    byId(id: string | null | undefined): Promise<ForloebModel> {
        let url_ = this.baseUrl + "/api/Forloeb/ById?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processById(_response);
        });
    }

    protected processById(response: Response): Promise<ForloebModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ForloebModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ForloebModel>(null as any);
    }

    update(model: ForloebModel): Promise<void> {
        let url_ = this.baseUrl + "/api/Forloeb/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    delete(id: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Forloeb/Delete?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    mineForloeb(dto: ForloebSearchDto): Promise<ForloebListDto> {
        let url_ = this.baseUrl + "/api/Forloeb/MineForloeb";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMineForloeb(_response);
        });
    }

    protected processMineForloeb(response: Response): Promise<ForloebListDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ForloebListDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ForloebListDto>(null as any);
    }

    addToFavorites(dto: FavoriteForloebDto): Promise<void> {
        let url_ = this.baseUrl + "/api/Forloeb/AddToFavorites";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddToFavorites(_response);
        });
    }

    protected processAddToFavorites(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    removeFromFavorites(dto: FavoriteForloebDto): Promise<void> {
        let url_ = this.baseUrl + "/api/Forloeb/RemoveFromFavorites";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveFromFavorites(_response);
        });
    }

    protected processRemoveFromFavorites(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    mineFavoritter(dto: ForloebSearchDto): Promise<ForloebListDto> {
        let url_ = this.baseUrl + "/api/Forloeb/MineFavoritter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMineFavoritter(_response);
        });
    }

    protected processMineFavoritter(response: Response): Promise<ForloebListDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ForloebListDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ForloebListDto>(null as any);
    }

    search(dto: ForloebSearchDto): Promise<ForloebListDto> {
        let url_ = this.baseUrl + "/api/Forloeb/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<ForloebListDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ForloebListDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ForloebListDto>(null as any);
    }
}

export class HeartbeatClient extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(): Promise<void> {
        let url_ = this.baseUrl + "/api/Heartbeat";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class LinkPreviewClient extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(url: string | null | undefined): Promise<LinkPreviewDto> {
        let url_ = this.baseUrl + "/api/LinkPreview?";
        if (url !== undefined && url !== null)
            url_ += "url=" + encodeURIComponent("" + url) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<LinkPreviewDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LinkPreviewDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LinkPreviewDto>(null as any);
    }
}

export class OidcConfigurationClient extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getClientRequestParameters(clientId: string | null): Promise<FileResponse> {
        let url_ = this.baseUrl + "/_configuration/{clientId}";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetClientRequestParameters(_response);
        });
    }

    protected processGetClientRequestParameters(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class PageClient extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(slug: string | null | undefined): Promise<PageDto> {
        let url_ = this.baseUrl + "/api/Page?";
        if (slug !== undefined && slug !== null)
            url_ += "slug=" + encodeURIComponent("" + slug) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<PageDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PageDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PageDto>(null as any);
    }

    put(model: PageDto): Promise<Page> {
        let url_ = this.baseUrl + "/api/Page";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<Page> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Page.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Page>(null as any);
    }
}

export class UserClient extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    byEmail(email: string | null | undefined): Promise<ForfatterDto> {
        let url_ = this.baseUrl + "/api/User/ByEmail?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processByEmail(_response);
        });
    }

    protected processByEmail(response: Response): Promise<ForfatterDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ForfatterDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ForfatterDto>(null as any);
    }
}

export class YoutubeClient extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(query: string | null | undefined, pageToken: string | null | undefined, maxResults: number | undefined): Promise<YoutubeResponseDto> {
        let url_ = this.baseUrl + "/api/Youtube?";
        if (query !== undefined && query !== null)
            url_ += "Query=" + encodeURIComponent("" + query) + "&";
        if (pageToken !== undefined && pageToken !== null)
            url_ += "PageToken=" + encodeURIComponent("" + pageToken) + "&";
        if (maxResults === null)
            throw new Error("The parameter 'maxResults' cannot be null.");
        else if (maxResults !== undefined)
            url_ += "MaxResults=" + encodeURIComponent("" + maxResults) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<YoutubeResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = YoutubeResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<YoutubeResponseDto>(null as any);
    }
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions?: { [key: string]: any; };

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
            if (_data["extensions"]) {
                this.extensions = {} as any;
                for (let key in _data["extensions"]) {
                    if (_data["extensions"].hasOwnProperty(key))
                        (<any>this.extensions)![key] = _data["extensions"][key];
                }
            }
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        if (this.extensions) {
            data["extensions"] = {};
            for (let key in this.extensions) {
                if (this.extensions.hasOwnProperty(key))
                    (<any>data["extensions"])[key] = (<any>this.extensions)[key];
            }
        }
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions?: { [key: string]: any; };

    [key: string]: any;
}

export class HttpValidationProblemDetails extends ProblemDetails implements IHttpValidationProblemDetails {
    errors?: { [key: string]: string[]; };

    [key: string]: any;

    constructor(data?: IHttpValidationProblemDetails) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (<any>this.errors)![key] = _data["errors"][key] !== undefined ? _data["errors"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): HttpValidationProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new HttpValidationProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (<any>data["errors"])[key] = (<any>this.errors)[key];
            }
        }
        super.toJSON(data);
        return data;
    }
}

export interface IHttpValidationProblemDetails extends IProblemDetails {
    errors?: { [key: string]: string[]; };

    [key: string]: any;
}

export class ValidationProblemDetails extends HttpValidationProblemDetails implements IValidationProblemDetails {
    errors?: { [key: string]: string[]; };

    [key: string]: any;

    constructor(data?: IValidationProblemDetails) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (<any>this.errors)![key] = _data["errors"][key] !== undefined ? _data["errors"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): ValidationProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (<any>data["errors"])[key] = (<any>this.errors)[key];
            }
        }
        super.toJSON(data);
        return data;
    }
}

export interface IValidationProblemDetails extends IHttpValidationProblemDetails {
    errors?: { [key: string]: string[]; };

    [key: string]: any;
}

export class CreateAccountModel implements ICreateAccountModel {
    email!: string;
    password!: string;
    confirmPassword!: string;
    fullName!: string;
    redirectUrl?: string | undefined;

    constructor(data?: ICreateAccountModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.password = _data["password"];
            this.confirmPassword = _data["confirmPassword"];
            this.fullName = _data["fullName"];
            this.redirectUrl = _data["redirectUrl"];
        }
    }

    static fromJS(data: any): CreateAccountModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAccountModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["password"] = this.password;
        data["confirmPassword"] = this.confirmPassword;
        data["fullName"] = this.fullName;
        data["redirectUrl"] = this.redirectUrl;
        return data;
    }
}

export interface ICreateAccountModel {
    email: string;
    password: string;
    confirmPassword: string;
    fullName: string;
    redirectUrl?: string | undefined;
}

export class LoginModel implements ILoginModel {
    email!: string;
    password!: string;
    rememberMe?: boolean;

    constructor(data?: ILoginModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.password = _data["password"];
            this.rememberMe = _data["rememberMe"];
        }
    }

    static fromJS(data: any): LoginModel {
        data = typeof data === 'object' ? data : {};
        let result = new LoginModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["password"] = this.password;
        data["rememberMe"] = this.rememberMe;
        return data;
    }
}

export interface ILoginModel {
    email: string;
    password: string;
    rememberMe?: boolean;
}

export class LoginAsModel implements ILoginAsModel {
    email?: string | undefined;

    constructor(data?: ILoginAsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): LoginAsModel {
        data = typeof data === 'object' ? data : {};
        let result = new LoginAsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data;
    }
}

export interface ILoginAsModel {
    email?: string | undefined;
}

export class ForgotPasswordModel implements IForgotPasswordModel {
    email!: string;
    redirectUrl!: string;

    constructor(data?: IForgotPasswordModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.redirectUrl = _data["redirectUrl"];
        }
    }

    static fromJS(data: any): ForgotPasswordModel {
        data = typeof data === 'object' ? data : {};
        let result = new ForgotPasswordModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["redirectUrl"] = this.redirectUrl;
        return data;
    }
}

export interface IForgotPasswordModel {
    email: string;
    redirectUrl: string;
}

export class ResetPasswordModel implements IResetPasswordModel {
    email!: string;
    password!: string;
    confirmPassword!: string;
    code!: string;

    constructor(data?: IResetPasswordModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.password = _data["password"];
            this.confirmPassword = _data["confirmPassword"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ResetPasswordModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["password"] = this.password;
        data["confirmPassword"] = this.confirmPassword;
        data["code"] = this.code;
        return data;
    }
}

export interface IResetPasswordModel {
    email: string;
    password: string;
    confirmPassword: string;
    code: string;
}

export class ConfigurationDto implements IConfigurationDto {
    muBaseUrl?: string | undefined;

    constructor(data?: IConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.muBaseUrl = _data["muBaseUrl"];
        }
    }

    static fromJS(data: any): ConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["muBaseUrl"] = this.muBaseUrl;
        return data;
    }
}

export interface IConfigurationDto {
    muBaseUrl?: string | undefined;
}

export class PostDto implements IPostDto {
    title?: string | undefined;
    excerpt?: string | undefined;
    date?: Date;
    link?: string | undefined;
    media?: MediaDto[] | undefined;

    constructor(data?: IPostDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.excerpt = _data["excerpt"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.link = _data["link"];
            if (Array.isArray(_data["media"])) {
                this.media = [] as any;
                for (let item of _data["media"])
                    this.media!.push(MediaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PostDto {
        data = typeof data === 'object' ? data : {};
        let result = new PostDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["excerpt"] = this.excerpt;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["link"] = this.link;
        if (Array.isArray(this.media)) {
            data["media"] = [];
            for (let item of this.media)
                data["media"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPostDto {
    title?: string | undefined;
    excerpt?: string | undefined;
    date?: Date;
    link?: string | undefined;
    media?: MediaDto[] | undefined;
}

export class MediaDto implements IMediaDto {
    mimeType?: string | undefined;
    url?: string | undefined;
    width?: number;
    height?: number;

    constructor(data?: IMediaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mimeType = _data["mimeType"];
            this.url = _data["url"];
            this.width = _data["width"];
            this.height = _data["height"];
        }
    }

    static fromJS(data: any): MediaDto {
        data = typeof data === 'object' ? data : {};
        let result = new MediaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mimeType"] = this.mimeType;
        data["url"] = this.url;
        data["width"] = this.width;
        data["height"] = this.height;
        return data;
    }
}

export interface IMediaDto {
    mimeType?: string | undefined;
    url?: string | undefined;
    width?: number;
    height?: number;
}

export class FagDto implements IFagDto {
    id?: string | undefined;
    uvmId?: number;
    navn?: string | undefined;

    constructor(data?: IFagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.uvmId = _data["uvmId"];
            this.navn = _data["navn"];
        }
    }

    static fromJS(data: any): FagDto {
        data = typeof data === 'object' ? data : {};
        let result = new FagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["uvmId"] = this.uvmId;
        data["navn"] = this.navn;
        return data;
    }
}

export interface IFagDto {
    id?: string | undefined;
    uvmId?: number;
    navn?: string | undefined;
}

export class FileUploadResponseDto implements IFileUploadResponseDto {
    uploadUrl?: string | undefined;
    blobproviderMetadataGuid?: string;

    constructor(data?: IFileUploadResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uploadUrl = _data["uploadUrl"];
            this.blobproviderMetadataGuid = _data["blobproviderMetadataGuid"];
        }
    }

    static fromJS(data: any): FileUploadResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileUploadResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uploadUrl"] = this.uploadUrl;
        data["blobproviderMetadataGuid"] = this.blobproviderMetadataGuid;
        return data;
    }
}

export interface IFileUploadResponseDto {
    uploadUrl?: string | undefined;
    blobproviderMetadataGuid?: string;
}

export class ValidFiletypesDto implements IValidFiletypesDto {
    images?: string[] | undefined;
    documents?: string[] | undefined;

    constructor(data?: IValidFiletypesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(item);
            }
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(item);
            }
        }
    }

    static fromJS(data: any): ValidFiletypesDto {
        data = typeof data === 'object' ? data : {};
        let result = new ValidFiletypesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item);
        }
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item);
        }
        return data;
    }
}

export interface IValidFiletypesDto {
    images?: string[] | undefined;
    documents?: string[] | undefined;
}

export class AfslutUploadResponseDto implements IAfslutUploadResponseDto {
    fileExistsInAzure?: boolean;

    constructor(data?: IAfslutUploadResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileExistsInAzure = _data["fileExistsInAzure"];
        }
    }

    static fromJS(data: any): AfslutUploadResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new AfslutUploadResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileExistsInAzure"] = this.fileExistsInAzure;
        return data;
    }
}

export interface IAfslutUploadResponseDto {
    fileExistsInAzure?: boolean;
}

export class AfslutFileUploadModel implements IAfslutFileUploadModel {
    blobproviderMetadataGuid?: string;

    constructor(data?: IAfslutFileUploadModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.blobproviderMetadataGuid = _data["blobproviderMetadataGuid"];
        }
    }

    static fromJS(data: any): AfslutFileUploadModel {
        data = typeof data === 'object' ? data : {};
        let result = new AfslutFileUploadModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["blobproviderMetadataGuid"] = this.blobproviderMetadataGuid;
        return data;
    }
}

export interface IAfslutFileUploadModel {
    blobproviderMetadataGuid?: string;
}

export class ForloebModel implements IForloebModel {
    id?: string | undefined;
    titel!: string;
    klassetrinFra?: number | undefined;
    klassetrinTil?: number | undefined;
    forfattere?: ForfatterDto[] | undefined;
    fag?: FagDto[] | undefined;
    kapitler?: KapitelDto[] | undefined;
    beskrivelseTilElev?: string | undefined;
    beskrivelseTilLaerer?: string | undefined;
    url?: string | undefined;
    billede?: string | undefined;
    visIBiblioteket?: boolean;
    visPaaMinUddannelse?: boolean;
    maaRedigere?: boolean;
    varighed?: number | undefined;
    kategorier?: string[] | undefined;

    constructor(data?: IForloebModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.titel = _data["titel"];
            this.klassetrinFra = _data["klassetrinFra"];
            this.klassetrinTil = _data["klassetrinTil"];
            if (Array.isArray(_data["forfattere"])) {
                this.forfattere = [] as any;
                for (let item of _data["forfattere"])
                    this.forfattere!.push(ForfatterDto.fromJS(item));
            }
            if (Array.isArray(_data["fag"])) {
                this.fag = [] as any;
                for (let item of _data["fag"])
                    this.fag!.push(FagDto.fromJS(item));
            }
            if (Array.isArray(_data["kapitler"])) {
                this.kapitler = [] as any;
                for (let item of _data["kapitler"])
                    this.kapitler!.push(KapitelDto.fromJS(item));
            }
            this.beskrivelseTilElev = _data["beskrivelseTilElev"];
            this.beskrivelseTilLaerer = _data["beskrivelseTilLaerer"];
            this.url = _data["url"];
            this.billede = _data["billede"];
            this.visIBiblioteket = _data["visIBiblioteket"];
            this.visPaaMinUddannelse = _data["visPaaMinUddannelse"];
            this.maaRedigere = _data["maaRedigere"];
            this.varighed = _data["varighed"];
            if (Array.isArray(_data["kategorier"])) {
                this.kategorier = [] as any;
                for (let item of _data["kategorier"])
                    this.kategorier!.push(item);
            }
        }
    }

    static fromJS(data: any): ForloebModel {
        data = typeof data === 'object' ? data : {};
        let result = new ForloebModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["titel"] = this.titel;
        data["klassetrinFra"] = this.klassetrinFra;
        data["klassetrinTil"] = this.klassetrinTil;
        if (Array.isArray(this.forfattere)) {
            data["forfattere"] = [];
            for (let item of this.forfattere)
                data["forfattere"].push(item.toJSON());
        }
        if (Array.isArray(this.fag)) {
            data["fag"] = [];
            for (let item of this.fag)
                data["fag"].push(item.toJSON());
        }
        if (Array.isArray(this.kapitler)) {
            data["kapitler"] = [];
            for (let item of this.kapitler)
                data["kapitler"].push(item.toJSON());
        }
        data["beskrivelseTilElev"] = this.beskrivelseTilElev;
        data["beskrivelseTilLaerer"] = this.beskrivelseTilLaerer;
        data["url"] = this.url;
        data["billede"] = this.billede;
        data["visIBiblioteket"] = this.visIBiblioteket;
        data["visPaaMinUddannelse"] = this.visPaaMinUddannelse;
        data["maaRedigere"] = this.maaRedigere;
        data["varighed"] = this.varighed;
        if (Array.isArray(this.kategorier)) {
            data["kategorier"] = [];
            for (let item of this.kategorier)
                data["kategorier"].push(item);
        }
        return data;
    }
}

export interface IForloebModel {
    id?: string | undefined;
    titel: string;
    klassetrinFra?: number | undefined;
    klassetrinTil?: number | undefined;
    forfattere?: ForfatterDto[] | undefined;
    fag?: FagDto[] | undefined;
    kapitler?: KapitelDto[] | undefined;
    beskrivelseTilElev?: string | undefined;
    beskrivelseTilLaerer?: string | undefined;
    url?: string | undefined;
    billede?: string | undefined;
    visIBiblioteket?: boolean;
    visPaaMinUddannelse?: boolean;
    maaRedigere?: boolean;
    varighed?: number | undefined;
    kategorier?: string[] | undefined;
}

export class ForfatterDto implements IForfatterDto {
    userId?: string | undefined;
    navn?: string | undefined;
    email?: string | undefined;

    constructor(data?: IForfatterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.navn = _data["navn"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): ForfatterDto {
        data = typeof data === 'object' ? data : {};
        let result = new ForfatterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["navn"] = this.navn;
        data["email"] = this.email;
        return data;
    }
}

export interface IForfatterDto {
    userId?: string | undefined;
    navn?: string | undefined;
    email?: string | undefined;
}

export class KapitelDto implements IKapitelDto {
    id!: string;
    overskrift!: string;
    laeringsmaal?: LaeringsmaalDto[] | undefined;
    sider!: SideDto[];

    constructor(data?: IKapitelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.sider = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.overskrift = _data["overskrift"];
            if (Array.isArray(_data["laeringsmaal"])) {
                this.laeringsmaal = [] as any;
                for (let item of _data["laeringsmaal"])
                    this.laeringsmaal!.push(LaeringsmaalDto.fromJS(item));
            }
            if (Array.isArray(_data["sider"])) {
                this.sider = [] as any;
                for (let item of _data["sider"])
                    this.sider!.push(SideDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): KapitelDto {
        data = typeof data === 'object' ? data : {};
        let result = new KapitelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["overskrift"] = this.overskrift;
        if (Array.isArray(this.laeringsmaal)) {
            data["laeringsmaal"] = [];
            for (let item of this.laeringsmaal)
                data["laeringsmaal"].push(item.toJSON());
        }
        if (Array.isArray(this.sider)) {
            data["sider"] = [];
            for (let item of this.sider)
                data["sider"].push(item.toJSON());
        }
        return data;
    }
}

export interface IKapitelDto {
    id: string;
    overskrift: string;
    laeringsmaal?: LaeringsmaalDto[] | undefined;
    sider: SideDto[];
}

export class LaeringsmaalDto implements ILaeringsmaalDto {
    id!: string;
    tekst!: string;
    tegnPaaLaering?: string[] | undefined;
    faellesmaal?: number[] | undefined;

    constructor(data?: ILaeringsmaalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tekst = _data["tekst"];
            if (Array.isArray(_data["tegnPaaLaering"])) {
                this.tegnPaaLaering = [] as any;
                for (let item of _data["tegnPaaLaering"])
                    this.tegnPaaLaering!.push(item);
            }
            if (Array.isArray(_data["faellesmaal"])) {
                this.faellesmaal = [] as any;
                for (let item of _data["faellesmaal"])
                    this.faellesmaal!.push(item);
            }
        }
    }

    static fromJS(data: any): LaeringsmaalDto {
        data = typeof data === 'object' ? data : {};
        let result = new LaeringsmaalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tekst"] = this.tekst;
        if (Array.isArray(this.tegnPaaLaering)) {
            data["tegnPaaLaering"] = [];
            for (let item of this.tegnPaaLaering)
                data["tegnPaaLaering"].push(item);
        }
        if (Array.isArray(this.faellesmaal)) {
            data["faellesmaal"] = [];
            for (let item of this.faellesmaal)
                data["faellesmaal"].push(item);
        }
        return data;
    }
}

export interface ILaeringsmaalDto {
    id: string;
    tekst: string;
    tegnPaaLaering?: string[] | undefined;
    faellesmaal?: number[] | undefined;
}

export class SideDto implements ISideDto {
    id!: string;
    overskrift!: string;
    elementer!: ElementDto[];

    constructor(data?: ISideDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.elementer = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.overskrift = _data["overskrift"];
            if (Array.isArray(_data["elementer"])) {
                this.elementer = [] as any;
                for (let item of _data["elementer"])
                    this.elementer!.push(ElementDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SideDto {
        data = typeof data === 'object' ? data : {};
        let result = new SideDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["overskrift"] = this.overskrift;
        if (Array.isArray(this.elementer)) {
            data["elementer"] = [];
            for (let item of this.elementer)
                data["elementer"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISideDto {
    id: string;
    overskrift: string;
    elementer: ElementDto[];
}

export class ElementDto implements IElementDto {
    id!: string;
    elementType!: ElementType;
    indhold!: string;
    erOpgave?: boolean;

    constructor(data?: IElementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.elementType = _data["elementType"];
            this.indhold = _data["indhold"];
            this.erOpgave = _data["erOpgave"];
        }
    }

    static fromJS(data: any): ElementDto {
        data = typeof data === 'object' ? data : {};
        let result = new ElementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["elementType"] = this.elementType;
        data["indhold"] = this.indhold;
        data["erOpgave"] = this.erOpgave;
        return data;
    }
}

export interface IElementDto {
    id: string;
    elementType: ElementType;
    indhold: string;
    erOpgave?: boolean;
}

export enum ElementType {
    Laererkommentar = 0,
    Text = 1,
    Link = 2,
    Picture = 3,
    Materiale = 4,
    Youtube = 5,
    File = 6,
}

export class ForloebListDto implements IForloebListDto {
    forloeb?: ForloebListItemDto[] | undefined;
    lastSeenId?: string | undefined;

    constructor(data?: IForloebListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["forloeb"])) {
                this.forloeb = [] as any;
                for (let item of _data["forloeb"])
                    this.forloeb!.push(ForloebListItemDto.fromJS(item));
            }
            this.lastSeenId = _data["lastSeenId"];
        }
    }

    static fromJS(data: any): ForloebListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ForloebListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.forloeb)) {
            data["forloeb"] = [];
            for (let item of this.forloeb)
                data["forloeb"].push(item.toJSON());
        }
        data["lastSeenId"] = this.lastSeenId;
        return data;
    }
}

export interface IForloebListDto {
    forloeb?: ForloebListItemDto[] | undefined;
    lastSeenId?: string | undefined;
}

export class ForloebListItemDto implements IForloebListItemDto {
    id?: string | undefined;
    titel?: string | undefined;
    billede?: string | undefined;
    favorit?: boolean;
    favoritter?: number;
    erKladde?: boolean;
    forfattere?: ForfatterDto[] | undefined;
    fag?: FagDto[] | undefined;
    klassetrinFra?: number;
    klassetrinTil?: number;
    kategorier?: string[] | undefined;

    constructor(data?: IForloebListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.titel = _data["titel"];
            this.billede = _data["billede"];
            this.favorit = _data["favorit"];
            this.favoritter = _data["favoritter"];
            this.erKladde = _data["erKladde"];
            if (Array.isArray(_data["forfattere"])) {
                this.forfattere = [] as any;
                for (let item of _data["forfattere"])
                    this.forfattere!.push(ForfatterDto.fromJS(item));
            }
            if (Array.isArray(_data["fag"])) {
                this.fag = [] as any;
                for (let item of _data["fag"])
                    this.fag!.push(FagDto.fromJS(item));
            }
            this.klassetrinFra = _data["klassetrinFra"];
            this.klassetrinTil = _data["klassetrinTil"];
            if (Array.isArray(_data["kategorier"])) {
                this.kategorier = [] as any;
                for (let item of _data["kategorier"])
                    this.kategorier!.push(item);
            }
        }
    }

    static fromJS(data: any): ForloebListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ForloebListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["titel"] = this.titel;
        data["billede"] = this.billede;
        data["favorit"] = this.favorit;
        data["favoritter"] = this.favoritter;
        data["erKladde"] = this.erKladde;
        if (Array.isArray(this.forfattere)) {
            data["forfattere"] = [];
            for (let item of this.forfattere)
                data["forfattere"].push(item.toJSON());
        }
        if (Array.isArray(this.fag)) {
            data["fag"] = [];
            for (let item of this.fag)
                data["fag"].push(item.toJSON());
        }
        data["klassetrinFra"] = this.klassetrinFra;
        data["klassetrinTil"] = this.klassetrinTil;
        if (Array.isArray(this.kategorier)) {
            data["kategorier"] = [];
            for (let item of this.kategorier)
                data["kategorier"].push(item);
        }
        return data;
    }
}

export interface IForloebListItemDto {
    id?: string | undefined;
    titel?: string | undefined;
    billede?: string | undefined;
    favorit?: boolean;
    favoritter?: number;
    erKladde?: boolean;
    forfattere?: ForfatterDto[] | undefined;
    fag?: FagDto[] | undefined;
    klassetrinFra?: number;
    klassetrinTil?: number;
    kategorier?: string[] | undefined;
}

export class ForloebSearchDto implements IForloebSearchDto {
    term?: string | undefined;
    fag?: string[] | undefined;
    trin?: number[] | undefined;
    kategorier?: string[] | undefined;
    lastSeenId?: string | undefined;
    limit?: number;
    erKladde?: boolean | undefined;

    constructor(data?: IForloebSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.term = _data["term"];
            if (Array.isArray(_data["fag"])) {
                this.fag = [] as any;
                for (let item of _data["fag"])
                    this.fag!.push(item);
            }
            if (Array.isArray(_data["trin"])) {
                this.trin = [] as any;
                for (let item of _data["trin"])
                    this.trin!.push(item);
            }
            if (Array.isArray(_data["kategorier"])) {
                this.kategorier = [] as any;
                for (let item of _data["kategorier"])
                    this.kategorier!.push(item);
            }
            this.lastSeenId = _data["lastSeenId"];
            this.limit = _data["limit"];
            this.erKladde = _data["erKladde"];
        }
    }

    static fromJS(data: any): ForloebSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new ForloebSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["term"] = this.term;
        if (Array.isArray(this.fag)) {
            data["fag"] = [];
            for (let item of this.fag)
                data["fag"].push(item);
        }
        if (Array.isArray(this.trin)) {
            data["trin"] = [];
            for (let item of this.trin)
                data["trin"].push(item);
        }
        if (Array.isArray(this.kategorier)) {
            data["kategorier"] = [];
            for (let item of this.kategorier)
                data["kategorier"].push(item);
        }
        data["lastSeenId"] = this.lastSeenId;
        data["limit"] = this.limit;
        data["erKladde"] = this.erKladde;
        return data;
    }
}

export interface IForloebSearchDto {
    term?: string | undefined;
    fag?: string[] | undefined;
    trin?: number[] | undefined;
    kategorier?: string[] | undefined;
    lastSeenId?: string | undefined;
    limit?: number;
    erKladde?: boolean | undefined;
}

export class FavoriteForloebDto implements IFavoriteForloebDto {
    forloebId?: string | undefined;

    constructor(data?: IFavoriteForloebDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.forloebId = _data["forloebId"];
        }
    }

    static fromJS(data: any): FavoriteForloebDto {
        data = typeof data === 'object' ? data : {};
        let result = new FavoriteForloebDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["forloebId"] = this.forloebId;
        return data;
    }
}

export interface IFavoriteForloebDto {
    forloebId?: string | undefined;
}

export class LinkPreviewDto implements ILinkPreviewDto {
    title?: string | undefined;
    image?: string | undefined;
    description?: string | undefined;

    constructor(data?: ILinkPreviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.image = _data["image"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): LinkPreviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new LinkPreviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["image"] = this.image;
        data["description"] = this.description;
        return data;
    }
}

export interface ILinkPreviewDto {
    title?: string | undefined;
    image?: string | undefined;
    description?: string | undefined;
}

export class PageDto implements IPageDto {
    slug?: string | undefined;
    content?: string | undefined;
    title?: string | undefined;

    constructor(data?: IPageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.slug = _data["slug"];
            this.content = _data["content"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): PageDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["slug"] = this.slug;
        data["content"] = this.content;
        data["title"] = this.title;
        return data;
    }
}

export interface IPageDto {
    slug?: string | undefined;
    content?: string | undefined;
    title?: string | undefined;
}

export class BaseEntity implements IBaseEntity {
    id?: string | undefined;

    constructor(data?: IBaseEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): BaseEntity {
        data = typeof data === 'object' ? data : {};
        let result = new BaseEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IBaseEntity {
    id?: string | undefined;
}

export class Page extends BaseEntity implements IPage {
    slug?: string | undefined;
    title?: string | undefined;
    content?: string | undefined;

    constructor(data?: IPage) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.slug = _data["slug"];
            this.title = _data["title"];
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): Page {
        data = typeof data === 'object' ? data : {};
        let result = new Page();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["slug"] = this.slug;
        data["title"] = this.title;
        data["content"] = this.content;
        super.toJSON(data);
        return data;
    }
}

export interface IPage extends IBaseEntity {
    slug?: string | undefined;
    title?: string | undefined;
    content?: string | undefined;
}

export class YoutubeResponseDto implements IYoutubeResponseDto {
    items?: YoutubeResponseItemDto[] | undefined;
    prevPageToken?: string | undefined;
    nextPageToken?: string | undefined;
    totalResults?: number;
    resultsPerPage?: number;

    constructor(data?: IYoutubeResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(YoutubeResponseItemDto.fromJS(item));
            }
            this.prevPageToken = _data["prevPageToken"];
            this.nextPageToken = _data["nextPageToken"];
            this.totalResults = _data["totalResults"];
            this.resultsPerPage = _data["resultsPerPage"];
        }
    }

    static fromJS(data: any): YoutubeResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new YoutubeResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["prevPageToken"] = this.prevPageToken;
        data["nextPageToken"] = this.nextPageToken;
        data["totalResults"] = this.totalResults;
        data["resultsPerPage"] = this.resultsPerPage;
        return data;
    }
}

export interface IYoutubeResponseDto {
    items?: YoutubeResponseItemDto[] | undefined;
    prevPageToken?: string | undefined;
    nextPageToken?: string | undefined;
    totalResults?: number;
    resultsPerPage?: number;
}

export class YoutubeResponseItemDto implements IYoutubeResponseItemDto {
    id?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    thumbnail?: string | undefined;
    thumbnailMedium?: string | undefined;
    thumbnailHigh?: string | undefined;
    thumbnailStandard?: string | undefined;
    thumbnailMaxRes?: string | undefined;

    constructor(data?: IYoutubeResponseItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.thumbnail = _data["thumbnail"];
            this.thumbnailMedium = _data["thumbnailMedium"];
            this.thumbnailHigh = _data["thumbnailHigh"];
            this.thumbnailStandard = _data["thumbnailStandard"];
            this.thumbnailMaxRes = _data["thumbnailMaxRes"];
        }
    }

    static fromJS(data: any): YoutubeResponseItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new YoutubeResponseItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["thumbnail"] = this.thumbnail;
        data["thumbnailMedium"] = this.thumbnailMedium;
        data["thumbnailHigh"] = this.thumbnailHigh;
        data["thumbnailStandard"] = this.thumbnailStandard;
        data["thumbnailMaxRes"] = this.thumbnailMaxRes;
        return data;
    }
}

export interface IYoutubeResponseItemDto {
    id?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    thumbnail?: string | undefined;
    thumbnailMedium?: string | undefined;
    thumbnailHigh?: string | undefined;
    thumbnailStandard?: string | undefined;
    thumbnailMaxRes?: string | undefined;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

/**
 * Configuration class needed in base class.
 * The config is provided to the API client at initialization time.
 * API clients inherit from #AuthorizedApiBase and provide the config.
 */
export class IConfig {
  /**
   * Returns a valid value for the Authorization header.
   * Used to dynamically inject the current auth header.
   */
    getAuthorization: () => 'the-authentication-token';
}